var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-content pay-management" },
    [
      _c("div", { staticClass: "grid-view" }, [
        _c("div", { staticClass: "main-content" }, [
          _c(
            "div",
            { staticClass: "section" },
            [
              _c(
                "el-form",
                {
                  attrs: {
                    inline: true,
                    "label-width": "100px",
                    "label-position": "left"
                  },
                  nativeOn: {
                    submit: function($event) {
                      $event.preventDefault()
                    }
                  }
                },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("CargoMsg.Cargo_CollectFeeType") }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            no: "itemType",
                            placeholder: _vm.$t("common.tips.pleaseChoose")
                          },
                          model: {
                            value: _vm.searchConditions.itemType,
                            callback: function($$v) {
                              _vm.$set(_vm.searchConditions, "itemType", $$v)
                            },
                            expression: "searchConditions.itemType"
                          }
                        },
                        _vm._l(_vm.itemTypeArray, function(item) {
                          return _c("el-option", {
                            key: item.code,
                            attrs: { label: item.desc, value: item.code }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("Information.ChargeGroup") } },
                    [
                      _c("cargo-advance-select", {
                        staticStyle: { width: "286px" },
                        attrs: {
                          no: "chargeGroupUuid",
                          filterable: "",
                          "select-type":
                            _vm.selectTypeNames.basic_data_ChargeGroup,
                          "tag-name": "name",
                          "tag-value": "uuid"
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.searchConditions.chargeGroupUuid = p.uuid
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "auto-width",
                      attrs: { "label-width": "0" }
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "286px" },
                        attrs: {
                          no: "name",
                          placeholder: _vm.$t(
                            "Message.PleaseEnterTheNameOfTheCosts"
                          )
                        },
                        on: {
                          change: function($event) {
                            _vm.searchConditions.pageNum = 1
                          }
                        },
                        nativeOn: {
                          keyup: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.fetchPayServiceList($event)
                          }
                        },
                        model: {
                          value: _vm.searchConditions.name,
                          callback: function($$v) {
                            _vm.$set(_vm.searchConditions, "name", $$v)
                          },
                          expression: "searchConditions.name"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { "label-width": "0" } },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { no: "fetchPayServiceList", type: "primary" },
                          on: { click: _vm.fetchPayServiceList }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Query")))]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm.$checkPermission(["write_SMChargeItem"])
            ? _c(
                "div",
                { staticClass: "section" },
                [
                  _c(
                    "el-form",
                    { attrs: { inline: true, "label-width": "0" } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "auto-width",
                          attrs: { "label-width": "0" }
                        },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                no: "popPayServiceAdd",
                                type: "primary"
                              },
                              on: { click: _vm.popPayServiceAddFormDialog }
                            },
                            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_NewTo")))]
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "auto-width",
                          attrs: { "label-width": "0" }
                        },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                no: "popPayServiceEdit",
                                type: "primary"
                              },
                              on: { click: _vm.popPayServiceEditFormDialog }
                            },
                            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Edit")))]
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "auto-width",
                          attrs: { "label-width": "0" }
                        },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { no: "toBatchDel", type: "danger" },
                              on: { click: _vm.toBatchDel }
                            },
                            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Delete")))]
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "auto-width",
                          attrs: { "label-width": "0" }
                        },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                no: "batchSettingDefault",
                                type: "primary"
                              },
                              on: { click: _vm.batchSettingDefault }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("CargoMsg.Cargo_SetUpDefaultsInBatch")
                                )
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "auto-width",
                          attrs: { "label-width": "0" }
                        },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                no: "batchCancelDefault",
                                type: "primary"
                              },
                              on: { click: _vm.batchCancelDefault }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("CargoMsg.Cargo_CancelDefaultsInBatch")
                                )
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "auto-width",
                          attrs: { "label-width": "0" }
                        },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                no: "popSettingServiceType",
                                type: "primary"
                              },
                              on: { click: _vm.popSettingServiceTypeDialog }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "CargoMsg.Cargo_SetUpServiceTypesInBatch"
                                  )
                                )
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "auto-width",
                          attrs: { "label-width": "0" }
                        },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                no: "combineChargeItem",
                                type: "primary"
                              },
                              on: { click: _vm.combineChargeItem }
                            },
                            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Combine")))]
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "auto-width",
                          attrs: { "label-width": "0" }
                        },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { no: "enable", type: "primary" },
                              on: {
                                click: function($event) {
                                  return _vm.enableOrNot(true)
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Enable")))]
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "auto-width",
                          attrs: { "label-width": "0" }
                        },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { no: "disable", type: "danger" },
                              on: {
                                click: function($event) {
                                  return _vm.enableOrNot(false)
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Disable")))]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _c(
            "div",
            {
              staticClass: "section grid-wrapper",
              staticStyle: { "min-height": "350px" }
            },
            [
              _c("cargo-ag-grid", {
                attrs: {
                  no: "100601-grid",
                  "config-module": "100601",
                  "grid-params": _vm.gridParams,
                  "grid-options": _vm.gridOptions,
                  "column-defs": _vm.columnDefs,
                  "row-data": _vm.rowData
                },
                on: {
                  "update:gridParams": function($event) {
                    _vm.gridParams = $event
                  },
                  "update:grid-params": function($event) {
                    _vm.gridParams = $event
                  }
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "pagination-wrapper" },
            [
              _c("cargo-pagination", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.searchConditions.total > 0,
                    expression: "searchConditions.total>0"
                  }
                ],
                attrs: {
                  no: "100601-pagination",
                  "config-module": "1006011",
                  total: _vm.searchConditions.total,
                  page: _vm.searchConditions.pageNum,
                  limit: _vm.searchConditions.pageSize
                },
                on: {
                  "update:page": function($event) {
                    return _vm.$set(_vm.searchConditions, "pageNum", $event)
                  },
                  "update:limit": function($event) {
                    return _vm.$set(_vm.searchConditions, "pageSize", $event)
                  },
                  pagination: _vm.fetchPayServiceList
                }
              })
            ],
            1
          )
        ])
      ]),
      _vm.showChargeItemMaintain
        ? _c(
            "el-dialog",
            {
              directives: [
                { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
              ],
              staticClass: "charge-item-maintain-dialog",
              attrs: {
                slot: "reference",
                no: "chargeItemManagementMaintain",
                "close-on-click-modal": false,
                visible: _vm.showChargeItemMaintain,
                title: _vm.chargeItemManagementMaintainTitle,
                "inline-message": "",
                width: _vm.isZh ? "500px" : "550px"
              },
              on: {
                "update:visible": function($event) {
                  _vm.showChargeItemMaintain = $event
                }
              },
              slot: "reference"
            },
            [
              _vm.showChargeItemMaintain
                ? _c(
                    "div",
                    [
                      _c(
                        "el-scrollbar",
                        { staticStyle: { height: "450px" } },
                        [
                          _c(
                            "el-form",
                            {
                              ref: "chargeItemManagementForm",
                              staticStyle: { "padding-right": "10px" },
                              attrs: {
                                model: _vm.chargeItemManagementForm,
                                "label-width": _vm.isZh ? "160px" : "210px",
                                "label-position": "left"
                              }
                            },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("CargoMsg.Cargo_Index")
                                  }
                                },
                                [
                                  _c("el-input", {
                                    attrs: { no: "itemId", disabled: "" },
                                    model: {
                                      value:
                                        _vm.chargeItemManagementForm.itemId,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.chargeItemManagementForm,
                                          "itemId",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "chargeItemManagementForm.itemId"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("CargoMsg.Cargo_DisplayOrder")
                                  }
                                },
                                [
                                  _c("el-input-number", {
                                    attrs: {
                                      no: "serialNumber",
                                      min: 0,
                                      max: 999,
                                      "controls-position": "right",
                                      disabled: _vm.isView
                                    },
                                    on: { change: _vm.serialNumberCharge },
                                    model: {
                                      value:
                                        _vm.chargeItemManagementForm
                                          .serialNumber,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.chargeItemManagementForm,
                                          "serialNumber",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "chargeItemManagementForm.serialNumber"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("CargoMsg.Cargo_abbreviation")
                                  }
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      no: "chargecode",
                                      maxlength: 8,
                                      disabled: _vm.isView
                                    },
                                    model: {
                                      value:
                                        _vm.chargeItemManagementForm.chargecode,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.chargeItemManagementForm,
                                          "chargecode",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "chargeItemManagementForm.chargecode"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "CargoMsg.Cargo_PlatformCode2"
                                    )
                                  }
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      no: "scaleCode",
                                      maxlength: 10,
                                      disabled: _vm.isView
                                    },
                                    model: {
                                      value:
                                        _vm.chargeItemManagementForm.scaleCode,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.chargeItemManagementForm,
                                          "scaleCode",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "chargeItemManagementForm.scaleCode"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("Information.ChargeGroup")
                                  }
                                },
                                [
                                  _c("cargo-advance-select", {
                                    attrs: {
                                      no: "chargeGroupUuid2",
                                      filterable: "",
                                      disabled: _vm.isView,
                                      "select-type":
                                        _vm.selectTypeNames
                                          .basic_data_ChargeGroup,
                                      "default-value":
                                        _vm.chargeItemManagementForm
                                          .chargeGroupUuid || "",
                                      "tag-name": "name",
                                      "tag-value": "uuid"
                                    },
                                    on: {
                                      parentCallBack: function(p) {
                                        _vm.chargeItemManagementForm.chargeGroupUuid =
                                          p.uuid
                                      }
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "CargoMsg.Cargo_InterchaneeCode"
                                    )
                                  }
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      no: "interchangeCode",
                                      disabled: _vm.isView
                                    },
                                    model: {
                                      value:
                                        _vm.chargeItemManagementForm
                                          .interchangeCode,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.chargeItemManagementForm,
                                          "interchangeCode",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "chargeItemManagementForm.interchangeCode"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("CargoMsg.Cargo_ChineseName")
                                  }
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      no: "zhName",
                                      disabled: _vm.isView
                                    },
                                    model: {
                                      value:
                                        _vm.chargeItemManagementForm.zhName,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.chargeItemManagementForm,
                                          "zhName",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "chargeItemManagementForm.zhName"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("CargoMsg.Cargo_EnglishName")
                                  }
                                },
                                [
                                  _c("charge-language-dialog", {
                                    staticStyle: { "margin-bottom": "10px" },
                                    attrs: {
                                      no: "enName",
                                      disabled: _vm.isView,
                                      items:
                                        _vm.chargeItemManagementForm
                                          .chargeLanguageValues
                                    },
                                    on: {
                                      childChargeLanguage:
                                        _vm.chargeLanguageValues
                                    },
                                    model: {
                                      value:
                                        _vm.chargeItemManagementForm.enName,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.chargeItemManagementForm,
                                          "enName",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "chargeItemManagementForm.enName"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("CargoMsg.Cargo_Metrics")
                                  }
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        no: "measure",
                                        placeholder: _vm.$t(
                                          "common.tips.pleaseChoose"
                                        ),
                                        disabled: _vm.isView
                                      },
                                      model: {
                                        value:
                                          _vm.chargeItemManagementForm.measure,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.chargeItemManagementForm,
                                            "measure",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "chargeItemManagementForm.measure"
                                      }
                                    },
                                    _vm._l(_vm.measureArray, function(item) {
                                      return _c("el-option", {
                                        key: item.code,
                                        attrs: {
                                          label:
                                            _vm.$store.getters.language === "zh"
                                              ? item.chineseName
                                              : item.englishName,
                                          value: item.code
                                        }
                                      })
                                    }),
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("CargoMsg.Cargo_ServiceItems")
                                  }
                                },
                                [
                                  _c("el-cascader", {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      no: "serviceType",
                                      options: _vm.serviceTypeArray,
                                      props: { checkStrictly: true },
                                      clearable: "",
                                      disabled: _vm.isView
                                    },
                                    on: { change: _vm.changeServiceType },
                                    model: {
                                      value:
                                        _vm.chargeItemManagementForm
                                          .serviceType,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.chargeItemManagementForm,
                                          "serviceType",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "chargeItemManagementForm.serviceType"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "CargoMsg.Cargo_AutoGenerateFeeName"
                                    )
                                  }
                                },
                                [
                                  _c("cargo-advance-select", {
                                    attrs: {
                                      filterable: "",
                                      "select-type":
                                        _vm.selectTypeNames
                                          .basic_data_ChargeItem,
                                      "default-value":
                                        _vm.chargeItemManagementForm
                                          .autoGenerateChargeId,
                                      disabled: _vm.isView,
                                      "tag-value": "itemId",
                                      "tag-name": "zhName",
                                      clearable: ""
                                    },
                                    on: {
                                      parentCallBack: function(p) {
                                        return (_vm.chargeItemManagementForm.autoGenerateChargeId =
                                          p.value)
                                      }
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "CargoMsg.Cargo_AutoGenerateTaxRate"
                                    )
                                  }
                                },
                                [
                                  _c("el-input-number", {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      disabled: _vm.isView,
                                      controls: false,
                                      precision: 2,
                                      min: 0
                                    },
                                    model: {
                                      value:
                                        _vm.chargeItemManagementForm
                                          .autoGenerateChargeTaxRate,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.chargeItemManagementForm,
                                          "autoGenerateChargeTaxRate",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "chargeItemManagementForm.autoGenerateChargeTaxRate"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "CargoMsg.Cargo_ForSeaExportBusiness"
                                    )
                                  }
                                },
                                [
                                  _c("el-checkbox", {
                                    attrs: {
                                      no: "seaExport",
                                      disabled: _vm.isView
                                    },
                                    model: {
                                      value:
                                        _vm.chargeItemManagementForm.seaExport,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.chargeItemManagementForm,
                                          "seaExport",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "chargeItemManagementForm.seaExport"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "CargoMsg.Cargo_ForSeaImportBusiness"
                                    )
                                  }
                                },
                                [
                                  _c("el-checkbox", {
                                    attrs: {
                                      no: "seaImport",
                                      disabled: _vm.isView
                                    },
                                    model: {
                                      value:
                                        _vm.chargeItemManagementForm.seaImport,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.chargeItemManagementForm,
                                          "seaImport",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "chargeItemManagementForm.seaImport"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "CargoMsg.Cargo_ForAirExportBusiness"
                                    )
                                  }
                                },
                                [
                                  _c("el-checkbox", {
                                    attrs: {
                                      no: "airExport",
                                      disabled: _vm.isView
                                    },
                                    model: {
                                      value:
                                        _vm.chargeItemManagementForm.airExport,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.chargeItemManagementForm,
                                          "airExport",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "chargeItemManagementForm.airExport"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "CargoMsg.Cargo_ForAirImportBusiness"
                                    )
                                  }
                                },
                                [
                                  _c("el-checkbox", {
                                    attrs: {
                                      no: "airImport",
                                      disabled: _vm.isView
                                    },
                                    model: {
                                      value:
                                        _vm.chargeItemManagementForm.airImport,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.chargeItemManagementForm,
                                          "airImport",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "chargeItemManagementForm.airImport"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "CargoMsg.Cargo_ForRailwayBusiness"
                                    )
                                  }
                                },
                                [
                                  _c("el-checkbox", {
                                    attrs: {
                                      no: "railwayExport",
                                      disabled: _vm.isView
                                    },
                                    model: {
                                      value:
                                        _vm.chargeItemManagementForm
                                          .railwayExport,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.chargeItemManagementForm,
                                          "railwayExport",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "chargeItemManagementForm.railwayExport"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "CargoMsg.Cargo_ForIntegratedJob"
                                    )
                                  }
                                },
                                [
                                  _c("el-checkbox", {
                                    attrs: {
                                      no: "integratedJob",
                                      disabled: _vm.isView
                                    },
                                    model: {
                                      value:
                                        _vm.chargeItemManagementForm
                                          .integratedJob,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.chargeItemManagementForm,
                                          "integratedJob",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "chargeItemManagementForm.integratedJob"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "CargoMsg.Cargo_ForFbaSeaBusiness"
                                    )
                                  }
                                },
                                [
                                  _c("el-checkbox", {
                                    attrs: {
                                      no: "fbaSea",
                                      disabled: _vm.isView
                                    },
                                    model: {
                                      value:
                                        _vm.chargeItemManagementForm.fbaSea,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.chargeItemManagementForm,
                                          "fbaSea",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "chargeItemManagementForm.fbaSea"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "CargoMsg.Cargo_ForFbaAirBusiness"
                                    )
                                  }
                                },
                                [
                                  _c("el-checkbox", {
                                    attrs: {
                                      no: "fbaAir",
                                      disabled: _vm.isView
                                    },
                                    model: {
                                      value:
                                        _vm.chargeItemManagementForm.fbaAir,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.chargeItemManagementForm,
                                          "fbaAir",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "chargeItemManagementForm.fbaAir"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "CargoMsg.Cargo_ForFbaRailwayBusiness"
                                    )
                                  }
                                },
                                [
                                  _c("el-checkbox", {
                                    attrs: {
                                      no: "fbaRailway",
                                      disabled: _vm.isView
                                    },
                                    model: {
                                      value:
                                        _vm.chargeItemManagementForm.fbaRailway,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.chargeItemManagementForm,
                                          "fbaRailway",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "chargeItemManagementForm.fbaRailway"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("Payment.controlledOrNot")
                                  }
                                },
                                [
                                  _c("el-checkbox", {
                                    attrs: {
                                      no: "controlled",
                                      disabled: _vm.isView
                                    },
                                    model: {
                                      value:
                                        _vm.chargeItemManagementForm.controlled,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.chargeItemManagementForm,
                                          "controlled",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "chargeItemManagementForm.controlled"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "CargoMsg.Cargo_NeedInvoiceOrNot"
                                    )
                                  }
                                },
                                [
                                  _c("el-checkbox", {
                                    attrs: {
                                      no: "needInvoice",
                                      disabled: _vm.isView
                                    },
                                    model: {
                                      value:
                                        _vm.chargeItemManagementForm
                                          .needInvoice,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.chargeItemManagementForm,
                                          "needInvoice",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "chargeItemManagementForm.needInvoice"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "CargoMsg.Cargo_CommissionOrNot"
                                    )
                                  }
                                },
                                [
                                  _c("el-checkbox", {
                                    attrs: {
                                      no: "commission",
                                      disabled: _vm.isView
                                    },
                                    model: {
                                      value:
                                        _vm.chargeItemManagementForm.commission,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.chargeItemManagementForm,
                                          "commission",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "chargeItemManagementForm.commission"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("CargoMsg.Cargo_AdvanceOrNot")
                                  }
                                },
                                [
                                  _c("el-checkbox", {
                                    attrs: {
                                      no: "advance",
                                      disabled: _vm.isView
                                    },
                                    model: {
                                      value:
                                        _vm.chargeItemManagementForm.advance,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.chargeItemManagementForm,
                                          "advance",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "chargeItemManagementForm.advance"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "CargoMsg.Cargo_SurchargeOrNot"
                                    )
                                  }
                                },
                                [
                                  _c("el-checkbox", {
                                    attrs: {
                                      no: "surcharge",
                                      disabled: _vm.isView
                                    },
                                    model: {
                                      value:
                                        _vm.chargeItemManagementForm.surcharge,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.chargeItemManagementForm,
                                          "surcharge",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "chargeItemManagementForm.surcharge"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "CargoMsg.Cargo_LocalChargeOrNot"
                                    )
                                  }
                                },
                                [
                                  _c("el-checkbox", {
                                    attrs: {
                                      no: "localCharge",
                                      disabled: _vm.isView
                                    },
                                    model: {
                                      value:
                                        _vm.chargeItemManagementForm
                                          .localCharge,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.chargeItemManagementForm,
                                          "localCharge",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "chargeItemManagementForm.localCharge"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "CargoMsg.Cargo_DestinationChargeOrNot"
                                    )
                                  }
                                },
                                [
                                  _c("el-checkbox", {
                                    attrs: {
                                      no: "desCharge",
                                      disabled: _vm.isView
                                    },
                                    model: {
                                      value:
                                        _vm.chargeItemManagementForm.desCharge,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.chargeItemManagementForm,
                                          "desCharge",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "chargeItemManagementForm.desCharge"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "CargoMsg.Cargo_IsItDefaultExpense"
                                    )
                                  }
                                },
                                [
                                  _c("el-checkbox", {
                                    attrs: {
                                      no: "defaultChargeItem",
                                      disabled: _vm.isView
                                    },
                                    model: {
                                      value:
                                        _vm.chargeItemManagementForm
                                          .defaultChargeItem,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.chargeItemManagementForm,
                                          "defaultChargeItem",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "chargeItemManagementForm.defaultChargeItem"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "CargoMsg.Cargo_IsCharterFlightCosts"
                                    )
                                  }
                                },
                                [
                                  _c("el-checkbox", {
                                    attrs: {
                                      no: "charterFlight",
                                      disabled: _vm.isView
                                    },
                                    model: {
                                      value:
                                        _vm.chargeItemManagementForm
                                          .charterFlight,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.chargeItemManagementForm,
                                          "charterFlight",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "chargeItemManagementForm.charterFlight"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "CargoMsg.Cargo_IsCharterVesselCosts"
                                    )
                                  }
                                },
                                [
                                  _c("el-checkbox", {
                                    attrs: {
                                      no: "charterVessel",
                                      disabled: _vm.isView
                                    },
                                    model: {
                                      value:
                                        _vm.chargeItemManagementForm
                                          .charterVessel,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.chargeItemManagementForm,
                                          "charterVessel",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "chargeItemManagementForm.charterVessel"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "CargoMsg.Cargo_OtherBusinessUse"
                                    )
                                  }
                                },
                                [
                                  _c("el-checkbox", {
                                    attrs: {
                                      no: "forothers",
                                      disabled: _vm.isView
                                    },
                                    model: {
                                      value:
                                        _vm.chargeItemManagementForm.forothers,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.chargeItemManagementForm,
                                          "forothers",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "chargeItemManagementForm.forothers"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("CargoMsg.Cargo_ZeroTaxRate")
                                  }
                                },
                                [
                                  _c("el-checkbox", {
                                    attrs: {
                                      no: "zeroTaxRate",
                                      disabled: _vm.isView
                                    },
                                    on: { change: _vm.changeZeroTaxRate },
                                    model: {
                                      value:
                                        _vm.chargeItemManagementForm
                                          .zeroTaxRate,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.chargeItemManagementForm,
                                          "zeroTaxRate",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "chargeItemManagementForm.zeroTaxRate"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "CargoMsg.Cargo_DefaultTaxRete"
                                    )
                                  }
                                },
                                [
                                  _c("el-input-number", {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      no: "taxRate",
                                      disabled:
                                        _vm.isView ||
                                        _vm.chargeItemManagementForm
                                          .zeroTaxRate,
                                      controls: false,
                                      precision: 2,
                                      min: 0
                                    },
                                    model: {
                                      value:
                                        _vm.chargeItemManagementForm.taxRate,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.chargeItemManagementForm,
                                          "taxRate",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "chargeItemManagementForm.taxRate"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("CargoMsg.Cargo_TaxRateRange")
                                  }
                                },
                                [
                                  _c("cargo-advance-select", {
                                    attrs: {
                                      no: "taxRateRage",
                                      "select-type":
                                        _vm.selectTypeNames
                                          .local_cache_TaxRateRanges,
                                      "callback-params": { key: "rateRange" },
                                      "callback-method-type": "value",
                                      filterable: "",
                                      clearable: true,
                                      multiple: true,
                                      "default-multiple-value":
                                        _vm.chargeItemManagementForm
                                          .rateRangeArr,
                                      disabled: _vm.isView
                                    },
                                    on: {
                                      parentCallBack: function(p) {
                                        _vm.chargeItemManagementForm.rateRange = p.value.join(
                                          ","
                                        )
                                      }
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "CargoMsg.Cargo_DefaultArSettlementObject"
                                    )
                                  }
                                },
                                [
                                  _c("cargo-advance-select", {
                                    attrs: {
                                      no: "defaultArAccountId",
                                      "select-type":
                                        _vm.selectTypeNames.basic_data_Company,
                                      "callback-params": {
                                        key: "defaultArAccountId"
                                      },
                                      "callback-method-type": "value",
                                      "default-value":
                                        _vm.chargeItemManagementForm
                                          .defaultArAccountId,
                                      filterable: "",
                                      disabled: _vm.isView
                                    },
                                    on: { parentCallBack: _vm.selectCargoItem }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("CargoMsg.Cargo_DefaultPayer")
                                  }
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        no: "defaultArCode",
                                        placeholder: _vm.$t(
                                          "common.tips.pleaseChoose"
                                        ),
                                        clearable: false,
                                        disabled: _vm.isView
                                      },
                                      on: { change: _vm.defaultArCodeChange },
                                      model: {
                                        value:
                                          _vm.chargeItemManagementForm
                                            .defaultArCode,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.chargeItemManagementForm,
                                            "defaultArCode",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "chargeItemManagementForm.defaultArCode"
                                      }
                                    },
                                    _vm._l(_vm.defaultObjArray, function(item) {
                                      return _c("el-option", {
                                        key: item.code,
                                        attrs: {
                                          label: item.desc,
                                          value: item.code
                                        }
                                      })
                                    }),
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "CargoMsg.Cargo_DefaultArSettlementObjectNull"
                                    )
                                  }
                                },
                                [
                                  _c("el-checkbox", {
                                    attrs: {
                                      no: "useDefaultArCode",
                                      disabled:
                                        _vm.isView ||
                                        (!_vm.isView &&
                                          _vm.chargeItemManagementForm
                                            .defaultArCode === "QXZ")
                                    },
                                    model: {
                                      value:
                                        _vm.chargeItemManagementForm
                                          .useDefaultArCode,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.chargeItemManagementForm,
                                          "useDefaultArCode",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "chargeItemManagementForm.useDefaultArCode"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "CargoMsg.Cargo_DefaultARCurrency"
                                    )
                                  }
                                },
                                [
                                  _c("cargo-advance-select", {
                                    staticStyle: { width: "205px" },
                                    attrs: {
                                      no: "defaultarcurrency",
                                      "select-type":
                                        _vm.selectTypeNames.basic_data_Currency,
                                      "callback-params": {
                                        key: "defaultarcurrency"
                                      },
                                      "callback-method-type": "value",
                                      "default-value":
                                        _vm.chargeItemManagementForm
                                          .defaultarcurrency,
                                      filterable: "",
                                      disabled: _vm.isView
                                    },
                                    on: { parentCallBack: _vm.selectCargoItem }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "CargoMsg.Cargo_DefaultReceivableMode"
                                    )
                                  }
                                },
                                [
                                  _c(
                                    "el-radio-group",
                                    {
                                      attrs: { no: "defaultArMode" },
                                      model: {
                                        value:
                                          _vm.chargeItemManagementForm
                                            .defaultArMode,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.chargeItemManagementForm,
                                            "defaultArMode",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "chargeItemManagementForm.defaultArMode"
                                      }
                                    },
                                    [
                                      _c(
                                        "el-radio",
                                        {
                                          attrs: {
                                            disabled: _vm.isView,
                                            label: false,
                                            value: false
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "CargoMsg.Cargo_DefaultUnitPrice"
                                              )
                                            )
                                          )
                                        ]
                                      ),
                                      _c(
                                        "el-radio",
                                        {
                                          attrs: {
                                            disabled: _vm.isView,
                                            label: true,
                                            value: true
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "CargoMsg.Cargo_DefaultRate"
                                              )
                                            )
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm.chargeItemManagementForm.defaultArMode == 0
                                ? _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          "CargoMsg.Cargo_DefaultARUnitPrice"
                                        )
                                      }
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          no: "defaultarprice",
                                          oninput:
                                            "value=value.replace(/[^0-9.]/g,'')",
                                          disabled: _vm.isView
                                        },
                                        model: {
                                          value:
                                            _vm.chargeItemManagementForm
                                              .defaultarprice,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.chargeItemManagementForm,
                                              "defaultarprice",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "chargeItemManagementForm.defaultarprice"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.chargeItemManagementForm.defaultArMode == 1
                                ? _c(
                                    "div",
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "CargoMsg.Cargo_DefaultReceivableRate"
                                            )
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticStyle: { display: "flex" }
                                            },
                                            [
                                              _c("el-checkbox", {
                                                attrs: {
                                                  no: "suitArRate",
                                                  disabled: _vm.isView
                                                },
                                                on: {
                                                  change: _vm.formatChargeRate
                                                },
                                                model: {
                                                  value:
                                                    _vm.chargeItemManagementForm
                                                      .suitArRate,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.chargeItemManagementForm,
                                                      "suitArRate",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "chargeItemManagementForm.suitArRate"
                                                }
                                              }),
                                              _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    "padding-left": "5px"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "CargoMsg.Cargo_Suit"
                                                      )
                                                    )
                                                  )
                                                ]
                                              ),
                                              _c("el-input-number", {
                                                staticStyle: {
                                                  "padding-left": "5px",
                                                  width: "250px"
                                                },
                                                attrs: {
                                                  no: "defaultArRate",
                                                  controls: false,
                                                  precision: 6,
                                                  disabled:
                                                    !_vm
                                                      .chargeItemManagementForm
                                                      .suitArRate || _vm.isView
                                                },
                                                model: {
                                                  value:
                                                    _vm.chargeItemManagementForm
                                                      .defaultArRate,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.chargeItemManagementForm,
                                                      "defaultArRate",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "chargeItemManagementForm.defaultArRate"
                                                }
                                              }),
                                              _vm._v("% ")
                                            ],
                                            1
                                          )
                                        ]
                                      ),
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "CargoMsg.Cargo_SecondReceivableRate"
                                            )
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticStyle: { display: "flex" }
                                            },
                                            [
                                              _c("el-checkbox", {
                                                attrs: {
                                                  no: "suitSecondArRate",
                                                  disabled: _vm.isView
                                                },
                                                on: {
                                                  change: _vm.formatChargeRate
                                                },
                                                model: {
                                                  value:
                                                    _vm.chargeItemManagementForm
                                                      .suitSecondArRate,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.chargeItemManagementForm,
                                                      "suitSecondArRate",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "chargeItemManagementForm.suitSecondArRate"
                                                }
                                              }),
                                              _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    "padding-left": "5px"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "CargoMsg.Cargo_Suit"
                                                      )
                                                    )
                                                  )
                                                ]
                                              ),
                                              _c("el-input-number", {
                                                staticStyle: {
                                                  "padding-left": "5px",
                                                  width: "250px"
                                                },
                                                attrs: {
                                                  no: "secondArRate",
                                                  controls: false,
                                                  precision: 6,
                                                  disabled:
                                                    !_vm
                                                      .chargeItemManagementForm
                                                      .suitSecondArRate ||
                                                    _vm.isView
                                                },
                                                model: {
                                                  value:
                                                    _vm.chargeItemManagementForm
                                                      .secondArRate,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.chargeItemManagementForm,
                                                      "secondArRate",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "chargeItemManagementForm.secondArRate"
                                                }
                                              }),
                                              _vm._v("% ")
                                            ],
                                            1
                                          )
                                        ]
                                      ),
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "CargoMsg.Cargo_ChargeableAmountInterval"
                                            )
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticStyle: { display: "flex" }
                                            },
                                            [
                                              _c("el-checkbox", {
                                                attrs: {
                                                  no: "suitArAmountInterval",
                                                  disabled: _vm.isView
                                                },
                                                on: {
                                                  change: _vm.formatChargeRate
                                                },
                                                model: {
                                                  value:
                                                    _vm.chargeItemManagementForm
                                                      .suitArAmountInterval,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.chargeItemManagementForm,
                                                      "suitArAmountInterval",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "chargeItemManagementForm.suitArAmountInterval"
                                                }
                                              }),
                                              _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    "padding-left": "5px"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "CargoMsg.Cargo_Suit"
                                                      )
                                                    )
                                                  )
                                                ]
                                              ),
                                              _c("el-input-number", {
                                                staticStyle: {
                                                  "padding-left": "5px",
                                                  width: "131px"
                                                },
                                                attrs: {
                                                  no: "arAmountIntervalMin",
                                                  controls: false,
                                                  precision: 2,
                                                  disabled:
                                                    !_vm
                                                      .chargeItemManagementForm
                                                      .suitArAmountInterval ||
                                                    _vm.isView
                                                },
                                                model: {
                                                  value:
                                                    _vm.chargeItemManagementForm
                                                      .arAmountIntervalMin,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.chargeItemManagementForm,
                                                      "arAmountIntervalMin",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "chargeItemManagementForm.arAmountIntervalMin"
                                                }
                                              }),
                                              _vm._v(" - "),
                                              _c("el-input-number", {
                                                staticStyle: { width: "131px" },
                                                attrs: {
                                                  no: "arAmountIntervalMax",
                                                  controls: false,
                                                  precision: 2,
                                                  disabled:
                                                    !_vm
                                                      .chargeItemManagementForm
                                                      .suitArAmountInterval ||
                                                    _vm.isView
                                                },
                                                model: {
                                                  value:
                                                    _vm.chargeItemManagementForm
                                                      .arAmountIntervalMax,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.chargeItemManagementForm,
                                                      "arAmountIntervalMax",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "chargeItemManagementForm.arAmountIntervalMax"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ]
                                      ),
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "CargoMsg.Cargo_ReceivableIntervalType"
                                            )
                                          }
                                        },
                                        [
                                          _c(
                                            "el-select",
                                            {
                                              staticStyle: { width: "100%" },
                                              attrs: {
                                                no: "arIntervalType",
                                                placeholder: _vm.$t(
                                                  "common.tips.pleaseChoose"
                                                ),
                                                clearable: false,
                                                disabled: _vm.isView
                                              },
                                              model: {
                                                value:
                                                  _vm.chargeItemManagementForm
                                                    .arIntervalType,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.chargeItemManagementForm,
                                                    "arIntervalType",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "chargeItemManagementForm.arIntervalType"
                                              }
                                            },
                                            _vm._l(
                                              _vm.intervalTypeArray,
                                              function(item) {
                                                return _c("el-option", {
                                                  key: item.code,
                                                  attrs: {
                                                    label: item.desc,
                                                    value: item.code
                                                  }
                                                })
                                              }
                                            ),
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "CargoMsg.Cargo_DefaultApSettlementObject"
                                    )
                                  }
                                },
                                [
                                  _c("cargo-advance-select", {
                                    attrs: {
                                      no: "defaultApAccountId",
                                      "select-type":
                                        _vm.selectTypeNames.basic_data_Company,
                                      "callback-params": {
                                        key: "defaultApAccountId"
                                      },
                                      "callback-method-type": "value",
                                      "default-value":
                                        _vm.chargeItemManagementForm
                                          .defaultApAccountId,
                                      filterable: "",
                                      disabled: _vm.isView
                                    },
                                    on: { parentCallBack: _vm.selectCargoItem }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("CargoMsg.Cargo_DefaultPayee")
                                  }
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        no: "defaultApCode",
                                        placeholder: _vm.$t(
                                          "common.tips.pleaseChoose"
                                        ),
                                        clearable: false,
                                        disabled: _vm.isView
                                      },
                                      on: { change: _vm.defaultApCodeChange },
                                      model: {
                                        value:
                                          _vm.chargeItemManagementForm
                                            .defaultApCode,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.chargeItemManagementForm,
                                            "defaultApCode",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "chargeItemManagementForm.defaultApCode"
                                      }
                                    },
                                    _vm._l(_vm.defaultObjArray, function(item) {
                                      return _c("el-option", {
                                        key: item.code,
                                        attrs: {
                                          label: item.desc,
                                          value: item.code
                                        }
                                      })
                                    }),
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "CargoMsg.Cargo_DefaultApSettlementObjectNull"
                                    )
                                  }
                                },
                                [
                                  _c("el-checkbox", {
                                    attrs: {
                                      no: "useDefaultApCode",
                                      disabled:
                                        _vm.isView ||
                                        (!_vm.isView &&
                                          _vm.chargeItemManagementForm
                                            .defaultApCode === "QXZ")
                                    },
                                    model: {
                                      value:
                                        _vm.chargeItemManagementForm
                                          .useDefaultApCode,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.chargeItemManagementForm,
                                          "useDefaultApCode",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "chargeItemManagementForm.useDefaultApCode"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "CargoMsg.Cargo_DefaultAPCurrency"
                                    )
                                  }
                                },
                                [
                                  _c("cargo-advance-select", {
                                    staticStyle: { width: "205px" },
                                    attrs: {
                                      no: "defaultapcurrency",
                                      "select-type":
                                        _vm.selectTypeNames.basic_data_Currency,
                                      "callback-params": {
                                        key: "defaultapcurrency"
                                      },
                                      "callback-method-type": "value",
                                      "default-value":
                                        _vm.chargeItemManagementForm
                                          .defaultapcurrency,
                                      filterable: "",
                                      disabled: _vm.isView
                                    },
                                    on: { parentCallBack: _vm.selectCargoItem }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "CargoMsg.Cargo_DefaultPayableMode"
                                    )
                                  }
                                },
                                [
                                  _c(
                                    "el-radio-group",
                                    {
                                      attrs: { no: "defaultApMode" },
                                      model: {
                                        value:
                                          _vm.chargeItemManagementForm
                                            .defaultApMode,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.chargeItemManagementForm,
                                            "defaultApMode",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "chargeItemManagementForm.defaultApMode"
                                      }
                                    },
                                    [
                                      _c(
                                        "el-radio",
                                        {
                                          attrs: {
                                            disabled: _vm.isView,
                                            label: false,
                                            value: false
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "CargoMsg.Cargo_DefaultUnitPrice"
                                              )
                                            )
                                          )
                                        ]
                                      ),
                                      _c(
                                        "el-radio",
                                        {
                                          attrs: {
                                            disabled: _vm.isView,
                                            label: true,
                                            value: true
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "CargoMsg.Cargo_DefaultRate"
                                              )
                                            )
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              !_vm.chargeItemManagementForm.defaultApMode
                                ? _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          "CargoMsg.Cargo_DefaultAPUnitPrice"
                                        )
                                      }
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          no: "defaultapprice",
                                          oninput:
                                            "value=value.replace(/[^0-9.]/g,'')",
                                          disabled: _vm.isView
                                        },
                                        model: {
                                          value:
                                            _vm.chargeItemManagementForm
                                              .defaultapprice,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.chargeItemManagementForm,
                                              "defaultapprice",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "chargeItemManagementForm.defaultapprice"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.chargeItemManagementForm.defaultApMode
                                ? _c(
                                    "div",
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "CargoMsg.Cargo_DefaultPayableRate"
                                            )
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticStyle: { display: "flex" }
                                            },
                                            [
                                              _c("el-checkbox", {
                                                attrs: {
                                                  no: "suitApRate",
                                                  disabled: _vm.isView
                                                },
                                                on: {
                                                  change: _vm.formatChargeRate
                                                },
                                                model: {
                                                  value:
                                                    _vm.chargeItemManagementForm
                                                      .suitApRate,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.chargeItemManagementForm,
                                                      "suitApRate",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "chargeItemManagementForm.suitApRate"
                                                }
                                              }),
                                              _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    "padding-left": "5px"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "CargoMsg.Cargo_Suit"
                                                      )
                                                    )
                                                  )
                                                ]
                                              ),
                                              _c("el-input-number", {
                                                staticStyle: {
                                                  "padding-left": "5px",
                                                  width: "250px"
                                                },
                                                attrs: {
                                                  no: "defaultApRate",
                                                  controls: false,
                                                  precision: 6,
                                                  disabled:
                                                    !_vm
                                                      .chargeItemManagementForm
                                                      .suitApRate || _vm.isView
                                                },
                                                model: {
                                                  value:
                                                    _vm.chargeItemManagementForm
                                                      .defaultApRate,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.chargeItemManagementForm,
                                                      "defaultApRate",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "chargeItemManagementForm.defaultApRate"
                                                }
                                              }),
                                              _vm._v("% ")
                                            ],
                                            1
                                          )
                                        ]
                                      ),
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "CargoMsg.Cargo_SecondRatePayable"
                                            )
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticStyle: { display: "flex" }
                                            },
                                            [
                                              _c("el-checkbox", {
                                                attrs: {
                                                  no: "suitSecondApRate",
                                                  disabled: _vm.isView
                                                },
                                                on: {
                                                  change: _vm.formatChargeRate
                                                },
                                                model: {
                                                  value:
                                                    _vm.chargeItemManagementForm
                                                      .suitSecondApRate,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.chargeItemManagementForm,
                                                      "suitSecondApRate",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "chargeItemManagementForm.suitSecondApRate"
                                                }
                                              }),
                                              _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    "padding-left": "5px"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "CargoMsg.Cargo_Suit"
                                                      )
                                                    )
                                                  )
                                                ]
                                              ),
                                              _c("el-input-number", {
                                                staticStyle: {
                                                  "padding-left": "5px",
                                                  width: "250px"
                                                },
                                                attrs: {
                                                  no: "secondApRate",
                                                  controls: false,
                                                  precision: 6,
                                                  disabled:
                                                    !_vm
                                                      .chargeItemManagementForm
                                                      .suitSecondApRate ||
                                                    _vm.isView
                                                },
                                                model: {
                                                  value:
                                                    _vm.chargeItemManagementForm
                                                      .secondApRate,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.chargeItemManagementForm,
                                                      "secondApRate",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "chargeItemManagementForm.secondApRate"
                                                }
                                              }),
                                              _vm._v("% ")
                                            ],
                                            1
                                          )
                                        ]
                                      ),
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "CargoMsg.Cargo_PayableAmountInterval"
                                            )
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticStyle: { display: "flex" }
                                            },
                                            [
                                              _c("el-checkbox", {
                                                attrs: {
                                                  no: "suitApAmountInterval",
                                                  disabled: _vm.isView
                                                },
                                                on: {
                                                  change: _vm.formatChargeRate
                                                },
                                                model: {
                                                  value:
                                                    _vm.chargeItemManagementForm
                                                      .suitApAmountInterval,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.chargeItemManagementForm,
                                                      "suitApAmountInterval",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "chargeItemManagementForm.suitApAmountInterval"
                                                }
                                              }),
                                              _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    "padding-left": "5px"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "CargoMsg.Cargo_Suit"
                                                      )
                                                    )
                                                  )
                                                ]
                                              ),
                                              _c("el-input-number", {
                                                staticStyle: {
                                                  "padding-left": "5px",
                                                  width: "131px"
                                                },
                                                attrs: {
                                                  no: "apAmountIntervalMin",
                                                  controls: false,
                                                  precision: 2,
                                                  disabled:
                                                    !_vm
                                                      .chargeItemManagementForm
                                                      .suitApAmountInterval ||
                                                    _vm.isView
                                                },
                                                model: {
                                                  value:
                                                    _vm.chargeItemManagementForm
                                                      .apAmountIntervalMin,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.chargeItemManagementForm,
                                                      "apAmountIntervalMin",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "chargeItemManagementForm.apAmountIntervalMin"
                                                }
                                              }),
                                              _vm._v(" - "),
                                              _c("el-input-number", {
                                                staticStyle: { width: "131px" },
                                                attrs: {
                                                  no: "apAmountIntervalMax",
                                                  controls: false,
                                                  precision: 2,
                                                  disabled:
                                                    !_vm
                                                      .chargeItemManagementForm
                                                      .suitApAmountInterval ||
                                                    _vm.isView
                                                },
                                                model: {
                                                  value:
                                                    _vm.chargeItemManagementForm
                                                      .apAmountIntervalMax,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.chargeItemManagementForm,
                                                      "apAmountIntervalMax",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "chargeItemManagementForm.apAmountIntervalMax"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ]
                                      ),
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "CargoMsg.Cargo_PayableIntervalType"
                                            )
                                          }
                                        },
                                        [
                                          _c(
                                            "el-select",
                                            {
                                              staticStyle: { width: "100%" },
                                              attrs: {
                                                no: "apIntervalType",
                                                placeholder: _vm.$t(
                                                  "common.tips.pleaseChoose"
                                                ),
                                                clearable: false,
                                                disabled: _vm.isView
                                              },
                                              model: {
                                                value:
                                                  _vm.chargeItemManagementForm
                                                    .apIntervalType,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.chargeItemManagementForm,
                                                    "apIntervalType",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "chargeItemManagementForm.apIntervalType"
                                              }
                                            },
                                            _vm._l(
                                              _vm.intervalTypeArray,
                                              function(item) {
                                                return _c("el-option", {
                                                  key: item.code,
                                                  attrs: {
                                                    label: item.desc,
                                                    value: item.code
                                                  }
                                                })
                                              }
                                            ),
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "CargoMsg.Cargo_RemarksOnAROrAPItems"
                                    )
                                  }
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      no: "remark",
                                      type: "text",
                                      disabled: _vm.isView
                                    },
                                    model: {
                                      value:
                                        _vm.chargeItemManagementForm.remark,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.chargeItemManagementForm,
                                          "remark",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "chargeItemManagementForm.remark"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("Information.DefaultWhtRate")
                                  }
                                },
                                [
                                  _c("el-input", {
                                    directives: [
                                      {
                                        name: "stopNumberMousewheel",
                                        rawName: "v-stopNumberMousewheel"
                                      }
                                    ],
                                    attrs: {
                                      no: "defaultWhtRate",
                                      value: _vm.toFixedIfNumber(
                                        _vm.chargeItemManagementForm
                                          .defaultWhtRate,
                                        2
                                      ),
                                      disabled: _vm.isView
                                    },
                                    on: {
                                      input: _vm.onDefaultWhtRateInput,
                                      change: _vm.onDefaultWhtRateChange
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                [
                                  _c("template", { slot: "label" }, [
                                    _c(
                                      "span",
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "Information.UncheckArApMate"
                                            )
                                          ) + " "
                                        ),
                                        _c(
                                          "el-tooltip",
                                          {
                                            staticClass: "item",
                                            staticStyle: { color: "#4AA4EA" },
                                            attrs: {
                                              content: _vm.$t(
                                                "Information.UncheckArApMateTip"
                                              ),
                                              placement: "top",
                                              effect: "light"
                                            }
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "el-icon-question",
                                              staticStyle: {
                                                "font-size": "16px",
                                                "vertical-align": "middle"
                                              }
                                            })
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ]),
                                  _c("el-checkbox", {
                                    attrs: {
                                      no: "uncheckArApMate",
                                      disabled: _vm.isView
                                    },
                                    model: {
                                      value:
                                        _vm.chargeItemManagementForm
                                          .uncheckArApMate,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.chargeItemManagementForm,
                                          "uncheckArApMate",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "chargeItemManagementForm.uncheckArApMate"
                                    }
                                  })
                                ],
                                2
                              ),
                              _vm.isMergeChargeItemSalesView
                                ? _c(
                                    "el-form-item",
                                    [
                                      _c("template", { slot: "label" }, [
                                        _c(
                                          "span",
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "Information.MergeAndDisplayToDesignatedFees"
                                                )
                                              ) + " "
                                            ),
                                            _c(
                                              "el-tooltip",
                                              {
                                                staticClass: "item",
                                                staticStyle: {
                                                  color: "#4AA4EA"
                                                },
                                                attrs: {
                                                  content: _vm.$t(
                                                    "Information.MergeAndDisplayToDesignatedFeesTips"
                                                  ),
                                                  placement: "top",
                                                  effect: "light"
                                                }
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "el-icon-question",
                                                  staticStyle: {
                                                    "font-size": "16px",
                                                    "vertical-align": "middle"
                                                  }
                                                })
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ]),
                                      _c("cargo-advance-select", {
                                        staticStyle: { width: "100%" },
                                        attrs: {
                                          filterable: "",
                                          "select-type":
                                            _vm.selectTypeNames
                                              .basic_data_ChargeItem,
                                          "default-value":
                                            Number(
                                              _vm.chargeItemManagementForm
                                                .targetItemId
                                            ) || "",
                                          "callback-method-type": "value",
                                          "tag-name": "zhName",
                                          "tag-value": "itemId",
                                          disabled: _vm.isView,
                                          cache: false,
                                          "static-options": _vm.chargeItemsList
                                        },
                                        on: {
                                          parentCallBack: function(p) {
                                            _vm.chargeItemManagementForm.targetItemId = p
                                          }
                                        }
                                      })
                                    ],
                                    2
                                  )
                                : _vm._e(),
                              _vm.isSpecialExpenseEntryFunction
                                ? _c(
                                    "el-form-item",
                                    [
                                      _c("template", { slot: "label" }, [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "CargoMsg.Cargo_SpecialExpenseIndicator"
                                              )
                                            )
                                          )
                                        ])
                                      ]),
                                      _c("el-checkbox", {
                                        attrs: {
                                          no: "specialExpenseMarker",
                                          disabled: _vm.isView
                                        },
                                        model: {
                                          value:
                                            _vm.chargeItemManagementForm
                                              .specialExpenseMarker,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.chargeItemManagementForm,
                                              "specialExpenseMarker",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "chargeItemManagementForm.specialExpenseMarker"
                                        }
                                      })
                                    ],
                                    2
                                  )
                                : _vm._e(),
                              _vm.isSpecialExpenseEntryFunction
                                ? _c(
                                    "el-form-item",
                                    [
                                      _c("template", { slot: "label" }, [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "CargoMsg.Cargo_BusinessSpecialExpenseIndicator"
                                              )
                                            )
                                          )
                                        ])
                                      ]),
                                      _c("el-checkbox", {
                                        attrs: {
                                          no: "businessSpecialMarker",
                                          disabled: _vm.isView
                                        },
                                        model: {
                                          value:
                                            _vm.chargeItemManagementForm
                                              .businessSpecialMarker,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.chargeItemManagementForm,
                                              "businessSpecialMarker",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "chargeItemManagementForm.businessSpecialMarker"
                                        }
                                      })
                                    ],
                                    2
                                  )
                                : _vm._e(),
                              _vm.isSpecialExpenseEntryFunction
                                ? _c(
                                    "el-form-item",
                                    [
                                      _c("template", { slot: "label" }, [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "CargoMsg.Cargo_IsNoInvoiceExpense"
                                              )
                                            )
                                          )
                                        ])
                                      ]),
                                      _c("el-checkbox", {
                                        attrs: {
                                          no: "noInvoiceFee",
                                          disabled: _vm.isView
                                        },
                                        model: {
                                          value:
                                            _vm.chargeItemManagementForm
                                              .noInvoiceFee,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.chargeItemManagementForm,
                                              "noInvoiceFee",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "chargeItemManagementForm.noInvoiceFee"
                                        }
                                      })
                                    ],
                                    2
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              !_vm.isView
                ? _c(
                    "div",
                    { attrs: { slot: "footer" }, slot: "footer" },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { no: "save", size: "size ", type: "primary" },
                          on: { click: _vm.submitPayService }
                        },
                        [_vm._v(_vm._s(_vm.$t("common.btn.save")))]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { no: "cancel", size: "size " },
                          on: { click: _vm.cancelSaveOrEdit }
                        },
                        [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
                      )
                    ],
                    1
                  )
                : _vm._e()
            ]
          )
        : _vm._e(),
      _vm.showServiceTypeMaintain
        ? _c(
            "el-dialog",
            {
              directives: [
                { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
              ],
              attrs: {
                no: "ServiceItems",
                "close-on-click-modal": false,
                visible: _vm.showServiceTypeMaintain,
                title: _vm.$t("CargoMsg.Cargo_ServiceItems"),
                width: "500px"
              },
              on: {
                "update:visible": function($event) {
                  _vm.showServiceTypeMaintain = $event
                }
              }
            },
            [
              _c(
                "el-form",
                {
                  ref: "serviceTypeForm",
                  attrs: {
                    model: _vm.serviceTypeForm,
                    "label-width": "120px",
                    "label-position": "right"
                  }
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("CargoMsg.Cargo_ServiceItems") } },
                    [
                      _c("el-cascader", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          no: "serviceType2",
                          options: _vm.setServiceTypeArray,
                          props: { checkStrictly: true },
                          clearable: ""
                        },
                        model: {
                          value: _vm.serviceTypeForm.serviceType,
                          callback: function($$v) {
                            _vm.$set(_vm.serviceTypeForm, "serviceType", $$v)
                          },
                          expression: "serviceTypeForm.serviceType"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                { attrs: { slot: "footer" }, slot: "footer" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { no: "save2", size: "size ", type: "primary" },
                      on: { click: _vm.submitServiceType }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.save")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { no: "cancel2", size: "size " },
                      on: { click: _vm.cancelServiceTypeSaveOrEdit }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm.combineChargeItemDialog.visible
        ? _c(
            "el-dialog",
            {
              directives: [
                { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
              ],
              attrs: {
                no: "CombineChargeItem",
                "close-on-click-modal": false,
                visible: _vm.combineChargeItemDialog.visible,
                title: _vm.$t("CargoMsg.Cargo_CombineChargeItem"),
                width: "1000px"
              },
              on: {
                "update:visible": function($event) {
                  return _vm.$set(
                    _vm.combineChargeItemDialog,
                    "visible",
                    $event
                  )
                }
              }
            },
            [
              _c(
                "el-form",
                {
                  attrs: { "label-width": "120px", "label-position": "right" }
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("CargoMsg.Cargo_PayService") } },
                    [
                      _c(
                        "span",
                        {
                          staticStyle: {
                            "font-size": "20px",
                            "font-weight": "bolder"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.combineChargeItemDialog.sourceChargeItemName
                            )
                          )
                        ]
                      )
                    ]
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_ConsolidatedChargeItem")
                      }
                    },
                    [
                      _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "286px" },
                            attrs: {
                              no: "name2",
                              placeholder: _vm.$t(
                                "Message.PleaseEnterTheNameOfTheCosts"
                              )
                            },
                            model: {
                              value: _vm.combineChargeItemDialog.name,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.combineChargeItemDialog,
                                  "name",
                                  $$v
                                )
                              },
                              expression: "combineChargeItemDialog.name"
                            }
                          }),
                          _c(
                            "el-button",
                            {
                              attrs: { no: "query", type: "primary" },
                              on: {
                                click: function($event) {
                                  return _vm.fetchChargeItem(1)
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Query")))]
                          )
                        ],
                        1
                      )
                    ]
                  )
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass: "section grid-wrapper",
                  staticStyle: { "min-height": "350px" }
                },
                [
                  _c("cargo-ag-grid", {
                    attrs: {
                      no: "1006022-grid",
                      "config-module": "1006022",
                      "grid-params": _vm.combineChargeItemDialog.gridParams,
                      "grid-options": _vm.combineChargeItemDialog.gridOptions,
                      "column-defs": _vm.columnDefs,
                      "row-data": _vm.combineChargeItemDialog.rowData
                    },
                    on: {
                      "update:gridParams": function($event) {
                        return _vm.$set(
                          _vm.combineChargeItemDialog,
                          "gridParams",
                          $event
                        )
                      },
                      "update:grid-params": function($event) {
                        return _vm.$set(
                          _vm.combineChargeItemDialog,
                          "gridParams",
                          $event
                        )
                      }
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "pagination-wrapper" },
                [
                  _c("cargo-pagination", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.combineChargeItemDialog.total > 0,
                        expression: "combineChargeItemDialog.total>0"
                      }
                    ],
                    attrs: {
                      no: "1006022-pagination",
                      "config-module": "1006022",
                      total: _vm.combineChargeItemDialog.total,
                      page: _vm.combineChargeItemDialog.pageNum,
                      limit: _vm.combineChargeItemDialog.pageSize
                    },
                    on: {
                      "update:page": function($event) {
                        return _vm.$set(
                          _vm.combineChargeItemDialog,
                          "pageNum",
                          $event
                        )
                      },
                      "update:limit": function($event) {
                        return _vm.$set(
                          _vm.combineChargeItemDialog,
                          "pageSize",
                          $event
                        )
                      },
                      pagination: _vm.fetchChargeItem
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                { attrs: { slot: "footer" }, slot: "footer" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { no: "confirm", size: "size ", type: "primary" },
                      on: { click: _vm.confirmCombine }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Confirm")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { no: "cancel2", size: "size " },
                      on: { click: _vm.cancelCombine }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }